// extracted by mini-css-extract-plugin
export default {"title":"N069tx","mobile":"IM933Y","info":"vrLbRo"};